/*
 * DD AdminUI
 * Copyright (C) Fraunhofer IESE 2019 - 2025 Stefan Schweitzer, Shyalan Ramesh, Rafael Aranda López King,
 * Florian Wege, Johannes Schneider, Kazi Rezoanur Rahman, Christoph Müller, Pedram Jokar,
 * Mher Ter-Tovmasyan, Ben Burkhard, Matthias Gerbershagen, Anna Kleiner, Muhammad Tariq,
 * Adeline Silva Schäfer
 *
 * SPDX-License-Identifier: Apache-2.0
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { useStore } from '../store';
import { AppVariant, Filter, Filters, FilterType, Tenant } from '../types';

type UseFilterBarProps = {
	filters: Filters;
	removeFilter: (removeFilter: Filter<AppVariant | Tenant>) => void;
	removeAllFilters: () => void;
	filteredTenantIds: string[];
	filteredAppVariantIds: string[];
};
const useFilterBar = (): UseFilterBarProps => {
	const { filters, removeAllFilters, removeFilter } = useStore();

	const filteredTenantIds = Object.values(filters[FilterType.TENANT])
		.filter(filter => !filter.isParentNode)
		.map(filter => filter.id);
	const filteredAppVariantIds = Object.values(filters[FilterType.APP_VARIANT])
		.filter(filter => !filter.isParentNode)
		.map(filter => filter.id);

	return { filters, removeFilter, removeAllFilters, filteredTenantIds, filteredAppVariantIds };
};

export default useFilterBar;
